import React from 'react';
import { observer } from "mobx-react";
import uniqueId from 'lodash/uniqueId';
import { Icon } from 'components/Icon';
import { ReperksIcon } from 'components/Svg';
import MenuItem from '../Menu/MenuItem';
import AdminMenuGroup from '../Menu/AdminMenuGroup';
import EcommerceMenu from '../Menu/EcommerceMenu';
import { DataMenu } from '../Menu/AdminMenuGroup';
import consoleStore from 'stores/Console/ConsoleStore';
import constants from 'Constants';
import * as auth from 'Auth';
import * as paths from 'Paths';
import * as utils from 'Utils';
import './styles.scss';




@observer
class OverviewMenu extends React.Component {
  constructor (props) {
    super(props);
    this.overviewUrl = paths.getPathReperksOverview();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.REPERKS_MENU.OVERVIEW);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.REPERKS_SIDEBAR.OVERVIEW;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.REPERKS_MENU.OVERVIEW}
        menuName="Overview"
        icon="home"
        href={this.overviewUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}




@observer
class ProgramMenu extends React.Component {
  constructor (props) {
    super(props);

    const qs = {};
    qs['theme'] = constants.PRODUCT_REPERKS;
    this.earningPointsUrl = utils.appendQueryString(paths.getPathReperksEarningPoints(), qs);
    this.rewardsUrl = utils.appendQueryString(paths.getPathReperksRewards(), qs);
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.REPERKS_MENU.PROGRAM);
    }
  }

  getSubMenus = () => {
    const { activeSidebar, history } = this.props;
    let subMenus = [{
        display: true,
        id: constants.REPERKS_SIDEBAR.EARNING_POINTS,
        label: "Earning Points",
        href: this.earningPointsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.earningPointsUrl),
        isActive: activeSidebar === constants.REPERKS_SIDEBAR.EARNING_POINTS
    }, {
        display: true,
        id: constants.REPERKS_SIDEBAR.STORE_REWARDS,
        label: "Store Rewards",
        href: this.rewardsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.rewardsUrl),
        isActive: activeSidebar === constants.REPERKS_SIDEBAR.STORE_REWARDS
    }];

    return subMenus;
  };

  checkIsActive = () => {
    return this.getSubMenus().some((subMenu) => subMenu.isActive);
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = this.getSubMenus();

    return (
      <MenuItem
        menuId={constants.REPERKS_MENU.PROGRAM}
        menuName="Program"
        icon="gift"
        subMenus={subMenus}
        isActive={this.checkIsActive()}
        {...this.props}
      />
    );
  }
}



@observer
class MembersMenu extends React.Component {
  constructor (props) {
    super(props);

    const qs = {};
    qs['theme'] = constants.PRODUCT_REPERKS;
    this.membersUrl = paths.getPathReperksMembers();
    this.activitiesUrl = paths.getPathReperksActivities();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.REPERKS_MENU.MEMBERS);
    }
  }

  getSubMenus = () => {
    const { activeSidebar, history } = this.props;
    let subMenus = [{
        display: true,
        id: constants.REPERKS_SIDEBAR.MEMBERS,
        label: "Manage Members",
        href: this.membersUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.membersUrl),
        isActive: activeSidebar === constants.REPERKS_SIDEBAR.MEMBERS
    }, {
        display: true,
        id: constants.REPERKS_SIDEBAR.ACTIVITIES,
        label: "Activities",
        href: this.activitiesUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.activitiesUrl),
        isActive: activeSidebar === constants.REPERKS_SIDEBAR.ACTIVITIES
    }];

    return subMenus;
  };

  checkIsActive = () => {
    return this.getSubMenus().some((subMenu) => subMenu.isActive);
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = this.getSubMenus();

    return (
      <MenuItem
        menuId={constants.REPERKS_MENU.MEMBERS}
        menuName="Members"
        icon="group"
        subMenus={subMenus}
        isActive={this.checkIsActive()}
        {...this.props}
      />
    );
  }
}





@observer
class AnalyticsMenu extends React.Component {
  constructor (props) {
    super(props);
    this.analyticsUrl = paths.getPathReperksAnalytics();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.REPERKS_MENU.ANALYTICS);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.REPERKS_SIDEBAR.ANALYTICS;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.REPERKS_MENU.ANALYTICS}
        menuName="Analytics"
        icon="bar-chart-square"
        href={this.analyticsUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}


@observer
class EmailsMenu extends React.Component {
  constructor (props) {
    super(props);

    const qs = {};
    qs['theme'] = constants.PRODUCT_REPERKS;
    this.emailsUrl = paths.getPathReperksEmails();
    this.emailDomainsUrl = utils.appendQueryString(paths.getPathEmailDomains(), qs);
    this.emailProfilesUrl = utils.appendQueryString(paths.getPathEmailProfiles(), qs);
    this.emailSettingsUrl = utils.appendQueryString(paths.getPathEmailSettings(), qs);
    this.smtpProfilesUrl = utils.appendQueryString(paths.getPathSmtpProfiles(), qs);
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.REPERKS_MENU.EMAILS);
    }
  }

  getSubMenus = () => {
    const { activeSidebar, history } = this.props;
    let subMenus = [{
        display: true,
        id: constants.REPERKS_SIDEBAR.EMAILS,
        label: "Reperks Emails",
        href: this.emailsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.emailsUrl),
        isActive: activeSidebar === constants.REPERKS_SIDEBAR.EMAILS
    }, {
        display: true,
        id: constants.REPERKS_SIDEBAR.EMAIL_PROFILES,
        label: "Email Profiles",
        href: this.emailProfilesUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.emailProfilesUrl),
        isActive: activeSidebar === constants.REPERKS_SIDEBAR.EMAIL_PROFILES
    }, {
        display: true,
        id: constants.REPERKS_SIDEBAR.EMAIL_SETTINGS,
        label: "Email Settings",
        href: this.emailSettingsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.emailSettingsUrl),
        isActive: activeSidebar === constants.REPERKS_SIDEBAR.EMAIL_SETTINGS
    }, {
        display: true,
        id: constants.REPERKS_SIDEBAR.SMTP_PROFILES,
        label: "SMTP Profiles",
        href: this.smtpProfilesUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.smtpProfilesUrl),
        isActive: activeSidebar === constants.REPERKS_SIDEBAR.SMTP_PROFILES
    }];

    return subMenus;
  };

  checkIsActive = () => {
    return this.getSubMenus().some((subMenu) => subMenu.isActive);
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = this.getSubMenus();

    return (
      <MenuItem
        menuId={constants.REPERKS_MENU.EMAILS}
        menuName="Emails"
        icon="mail-send"
        subMenus={subMenus}
        isActive={this.checkIsActive()}
        {...this.props}
      />
    );
  }
}




@observer
class ConnectionsMenu extends React.Component {
  constructor (props) {
    super(props);
    this.connectionsUrl = paths.getPathReperksConnections();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.REPERKS_MENU.CONNECTIONS);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.REPERKS_SIDEBAR.CONNECTIONS;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.REPERKS_MENU.CONNECTIONS}
        menuName="Connections"
        icon="shape-circle"
        href={this.connectionsUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}



@observer
class ReperksSidebar extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      activeMenu: "",
    };
  }

  componentDidMount() {
    auth.setCurrentProduct(constants.PRODUCT_REPERKS);
  }

  updateActiveMenu = (activeMenu) => {
    if (this.state.activeMenu === activeMenu) {
      this.setState({activeMenu: ""});
      return;
    }

    this.setState({activeMenu: activeMenu});
  };

  render() {
    const account = consoleStore.account;

    return (
      <div className="sidebar sidebar-reperks">
        <div className="sidebar-head">
          <div className="head-icon"><ReperksIcon /></div>
          <div className="head-title">Reperks</div>
        </div>

        <div className="menu-items">
          <div className="menu-group">
            <OverviewMenu
              isActive={this.state.activeMenu === constants.REPERKS_MENU.OVERVIEW}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <ProgramMenu
              isActive={this.state.activeMenu === constants.REPERKS_MENU.PROGRAM}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <MembersMenu
              isActive={this.state.activeMenu === constants.REPERKS_MENU.MEMBERS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <AnalyticsMenu
              isActive={this.state.activeMenu === constants.REPERKS_MENU.ANALYTICS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <EmailsMenu
              isActive={this.state.activeMenu === constants.REPERKS_MENU.EMAILS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <EcommerceMenu
              theme={constants.PRODUCT_REPERKS}
              displayProducts={true}
              isActive={this.state.activeMenu === constants.REPERKS_MENU.ECOMMERCE}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <ConnectionsMenu
              isActive={this.state.activeMenu === constants.REPERKS_MENU.CONNECTIONS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <DataMenu
              isActive={this.state.activeMenu === constants.REPERKS_MENU.DATA}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />
          </div>

          <AdminMenuGroup
            activeMenu={this.state.activeMenu}
            updateActiveMenu={this.updateActiveMenu}
            product={constants.PRODUCT_REPERKS}
            {...this.props}
          />
        </div>
      </div>
    );
  }
}



export { ReperksSidebar };

